import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Don't scroll to top if there's a hash (anchor link) in the URL
    // The anchor scrolling will be handled by the page component
    if (hash) {
      return;
    }
    
    // Scroll to top when route changes (without hash)
    window.scrollTo({
      top: 0,
      behavior: 'instant' // Use instant instead of smooth for immediate feedback
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;





